module.exports = __webpack_public_path__ + "static/media/Anonymous.97e1e368.svg";